import React, { useState, useEffect } from "react";
import Commonheader from "./Commonheader";
import useAxios from "../hooks/useAxios";
import { Button } from "antd";
import { EditOutlined } from "@ant-design/icons";

function ServiceConfiguration(props) {
  const [loading, sendRequest] = useAxios();
  const [viewList, setviewList] = useState();
  const [isErrOpen, setisErrOpen] = useState(false);
  const [api_error_message, setapi_error_message] = useState();
  const [config_data,setconfig_data] = useState([]);
  // const [api_token, setapi_token] = useState("test-token-for-collection-app");

  useEffect(() => {
    fetchConfigData();
  }, []);

  const fetchConfigData = () => {

    let api_token = localStorage.getItem("api_token");

    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/mongo/get/configuration_master/service_configuration`,
        method: "GET",
        headers: {
          "api-token": api_token,
        },
      },
      (response) => {
        // console.log(JSON.stringify(response));

        // console.log(response.length);
        // if (response.length > 0) {
        setconfig_data(response);
        // }
        // console.log(config_data);
      },
      (error) => {
        console.error("API request failed:", error);
      }
    );
  };


  return (
    <div className="container">
      <Commonheader pagetitle={"Service Configuration List"} props={props} />
      {loading && (
        <div class="load-4">
          <div class="ring-1"></div>
        </div>
      )}
      <div
        className={
          isErrOpen
            ? "modal fade show d-block mymodal"
            : "modal fade bd-example-modal-sm"
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <button
              type="button"
              className="close text-right"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setisErrOpen(false);
                window.location.reload();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="popuperrtext">{api_error_message}</p>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th scope="col">Service Name</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {config_data &&
              config_data.map((item) => (
                <tr>
                  <td>{item.service}</td>
                  
                  <td>
                    <button
                      type="button"
                      class="btn btn-outline-info"
                      onClick={() =>
                        props.history.push({
                          pathname: "/Service-clone",
                          state: {
                            sel_config_data: item
                          },
                        })
                      }
                    >
                      <EditOutlined />
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ServiceConfiguration;
